import { mapGetters } from 'vuex'

import * as Vehicle from '@/services/rest-api/lib/fleet-task/vehicle'
import * as DriverAvailability from '@/services/rest-api/lib/fleet-task-instant/driver'
import store from '@/state/store'
import { Helper } from '@/mixin/helper'

const getFeatureFlagValue = store.getters['identity/getFeatureFlagValue']

let customFeature = {}
function hasCustomFeatureMGM() {
  const data = getFeatureFlagValue('customFeature.mgm')
  customFeature.mgm = data
  return Array.isArray(data?.company_id) && data.company_id.includes(Helper.methods.getCompanyId())
}

export default {
  computed: {
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
    }),
    fields() {
      return [
        {
          key: 'number',
          label: 'Kode',
          thAttr: {
            style: 'min-width:80px;',
          },
          tdAttr: {
            style: 'vertical-align:middle;',
          },
        },
        {
          key: 'vehicle_type.name',
          name: 'vehicle_type_id',
          label: 'Jenis Kendaraan',
          type: 'select-resourceful-v2',
          placeholder: 'Pilih jenis kendaraan',
          isEditable: true,
          trackBy: 'id',
          optionsGetter: async (opts) => {
            const filters = [...(opts?.filters || [])]
            if (hasCustomFeatureMGM() && customFeature.mgm.filtered_vehicle_category) {
              const categoryList = customFeature.mgm.filtered_vehicle_category.map((c) => `'${c}'`).join(',')
              filters.push(`category in (${categoryList})`)
            }
            return await Vehicle.getVehicleType({ ...opts, filters: filters.length > 0 ? filters : undefined })
          },
          optionLabelFn: ({ item }) => `${item.manufacturer} - ${item.model} - ${item.type}`,
          selectedLabel: 'type',
          formatter: (value) => ((value ?? '') === '' ? '-' : value),
          thAttr: {
            style: 'min-width:250px;',
          },
          tdAttr: {
            style: 'vertical-align:middle;',
          },
        },
        {
          key: 'vehicle.license_plate',
          name: 'vehicle_id',
          label: 'Plat Nomor',
          type: 'select-resourceful-v2',
          placeholder: 'Pilih plat nomor',
          isEditable: true,
          trackBy: 'id',
          optionsGetter: this.fetchVehicle,
          optionLabelFn: ({ item }) => item.license_plate,
          formatter: (value) => ((value ?? '') === '' ? '-' : value),
          thAttr: {
            style: 'min-width:200px;',
          },
          tdAttr: {
            style: 'vertical-align:middle;',
          },
          disabledFn: () => this.formValues?.['vehicle_type_id'] === null || this.formValues?.['vehicle_type_id'] === undefined,
        },
        {
          key: 'driver_user.name',
          name: 'driver_user_id',
          label: 'Pengemudi Utama',
          type: 'select-resourceful-v2',
          placeholder: 'Pilih pengemudi utama',
          isEditable: true,
          trackBy: 'id',
          optionsGetter: (opts) => this.fetchDriver(opts, this.formValues?.driver_user_2_id),
          optionLabelFn: ({ item }) => item.name,
          formatter: (value) => ((value ?? '') === '' ? '-' : value),
          thAttr: {
            style: 'min-width:280px;',
          },
          tdAttr: {
            style: 'vertical-align:middle;',
          },
          disabledFn: () => (this.formValues?.['vehicle_id'] === null || this.formValues?.['vehicle_id'] === undefined) || (this.hasDriverCompatibility && (this.formValues?.['vehicle_type_id'] === null || this.formValues?.['vehicle_type_id'] === undefined)),
        },
        {
          key: 'driver_user_2.name',
          name: 'driver_user_2_id',
          label: 'Pengemudi Tambahan',
          type: 'select-resourceful-v2',
          placeholder: 'Pilih pengemudi tambahan',
          isEditable: true,
          trackBy: 'id',
          optionsGetter: (opts) => this.fetchDriver(opts, this.formValues?.driver_user_id),
          optionLabelFn: ({ item }) => item.name,
          formatter: (value) => ((value ?? '') === '' ? '-' : value),
          thAttr: {
            style: 'min-width:280px;',
          },
          tdAttr: {
            style: 'vertical-align:middle;',
          },
          disabledFn: () => (this.formValues?.['vehicle_id'] === null || this.formValues?.['vehicle_id'] === undefined) || (this.hasDriverCompatibility && (this.formValues?.['vehicle_type_id'] === null || this.formValues?.['vehicle_type_id'] === undefined)),
        },
        {
          key: 'usage_percentage',
          label: 'Penggunaan Kendaraan (%)',
          readOnly: true,
          thAttr: {
            style: 'min-width:220px;',
          },
          tdAttr: {
            style: 'vertical-align:middle;',
          },
        },
        {
          key: 'total_mileage',
          name: 'total_mileage',
          label: 'Jarak Tempuh (km)',
          type: 'text',
          _type: 'number',
          validation: 'bail|number|min:0,value',
          placeholder: 'Masukkan jarak tempuh (km)',
          isEditable: true,
          thAttr: {
            style: 'min-width:250px;',
          },
          tdAttr: {
            style: 'vertical-align:middle;',
          },
          disabledFn: () => this.isAdding,
        },
        {
          key: 'return_date',
          name: 'return_date',
          label: 'Tanggal Kembali',
          type: 'date-picker',
          datepickerType: 'date',
          placeholder: 'Pilih tanggal kembali',
          isEditable: true,
          valueType: 'YYYY-MM-DD',
          format: 'DD MMM YYYY',
          confirm: true,
          confirmText: 'Terapkan',
          customColumn: true,
          thAttr: {
            style: 'min-width:200px;',
          },
          tdAttr: {
            style: 'vertical-align:middle;',
          },
          disabledFn: () => this.isAdding,
          errorBehavior: 'live',
          validationBehavior: 'live',
        },
        {
          key: 'status.name',
          label: 'Status',
          thAttr: {
            style: 'min-width:100px;',
          },
          tdAttr: {
            style: 'vertical-align:middle;',
          },
          readOnly: true,
        },
      ]
    },
    hasDriverCompatibility() {
      return this.hasAccessAll([
        'driver-compatibility:read',
        'driver-compatibility:update',
      ])
    }
  },
  methods: {
    async fetchVehicle(opts) {
      const filters = []

      if (this.formValues?.vehicle_type_id !== null && this.formValues?.vehicle_type_id !== undefined) {
        filters.push(`vehicle_type.id eq ${this.formValues?.vehicle_type_id}`)
      }

      opts = {
        ...opts,
        filters: filters.length > 0 ? filters : undefined,
      }

      return await Vehicle.get(opts)
    },
    async fetchDriver(opts) {
      if (this.hasDriverCompatibility) {
        const vehicleCategory = this.fullObjects?.vehicle_type_id?.category

        if (vehicleCategory !== '' && vehicleCategory !== null && vehicleCategory !== undefined) {
          opts = {
            ...opts,
            vehicle_category: vehicleCategory ?? undefined,
          }
        }
      }
      
      return await DriverAvailability.get(opts)
    },
  }
}
